import { render, staticRenderFns } from "./WazeLink.vue?vue&type=template&id=a1ca120c&"
import script from "./WazeLink.vue?vue&type=script&lang=js&"
export * from "./WazeLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports